import fetchJSON from '../fetchJSON';
import {once} from 'lodash';

export default once(async (): Promise<User> => {
    return fetchJSON.memoized('/profile/api/');
});
